var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_31",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 31",
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    fill: "#7975fc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftImage);
export default __webpack_public_path__ + "static/media/leftImage.13f73439fad89e753ab01c5307521b46.svg";
export { ForwardRef as ReactComponent };